import React from "react";
import PDF from "react-pdf-js";
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";

export default class ReportsViewer extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            page: 1, 
            scale: 1.5,
            pages: null
        };

        this.onDocumentCompleted = this.onDocumentCompleted.bind(this);
        this.onPageCompleted = this.onPageCompleted.bind(this);
        this.handlePrevious = this.handlePrevious.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.renderPagination = this.renderPagination.bind(this);

        this.setScale();
    }

    setScale() {
        if (this.props.scale !== null) {
            this.setState({
                scale: this.props.scale
            });
        }
    }

    onDocumentCompleted(pages) {
        this.setState({
            page: 1,
            pages: pages
        });
    }

    onPageCompleted(page) {
        this.setState({
            currentPage: page
        });
    }

    handlePrevious() {
        this.setState({ 
            page: this.state.page - 1 
        });
    }

    handleNext() {
        this.setState({ 
            page: this.state.page + 1 
        });
    }

    renderPagination(page, pages) {
        let previousButton = <li className="previous" onClick={this.handlePrevious}><a href="#"><i className="fa fa-arrow-left"></i> Previous</a></li>;
        if (page === 1) {
            previousButton = <li className="previous disabled"><a href="#"><i className="fa fa-arrow-left"></i> Previous</a></li>;
        }
        
        let nextButton = <li className="next" onClick={this.handleNext}><a href="#">Next <i className="fa fa-arrow-right"></i></a></li>;
        if (page === pages) {
            nextButton = <li className="next disabled"><a href="#">Next <i className="fa fa-arrow-right"></i></a></li>;
        }
        
        return (
            <ul className="pager">
                {previousButton}
                {nextButton}
            </ul>
        );
   }

    render() {
        
        let viewer = null;

        if (this.props.reportData == null) {
            viewer = <div className="col-md-12 col-lg-12"></div>;
        }
        else {
            let pagination = null;
            if (this.state.pages) {
                pagination = this.renderPagination(this.state.page, this.state.pages);
            }
            viewer =
                <div>
                    {pagination}
                    <PDF content={this.props.reportData}
                        page={this.state.page}
                        scale={this.state.scale}
                        onDocumentComplete={this.onDocumentCompleted}
                        onPageComplete={this.onPageCompleted}
                        loading={(<span>Loading ...</span>)} />
                </div>;

            console.log(this.props);
            console.log(this.state);
        }

        return (
            <div className="col-md-12 col-lg-12">
                {viewer}
            </div>
        );
    }
}